export const isNumber = (val:any) => {
    return /^-?\d+$/.test(val);
}